import { defineComponent } from 'vue';
// Shown above a game page for as long as the judge has the game frozen.
export default defineComponent({
    name: 'FrozenBanner',
});
